// Section Shopify Shopify.theme editor events

$(document)
.on('shopify:section:reorder', function(e){

  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if (Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.unload();
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

});

$(document)
.on('shopify:section:load', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];

      // Check to see if section script exists
      if (typeof Shopify.theme[triggerClass] == 'undefined') {
        // make AJAX call to load script
        Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
          Shopify.theme[triggerClass].init($(section));
        });
      } else {
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(section));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          var $block = $('.'+ triggerClass)
          var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

          // Check to see if section script exists
          if (typeof Shopify.theme[triggerClass] == 'undefined') {
            // make AJAX call to load script
            Shopify.theme.loadScript(triggerClass, blockUrl, function () {
              Shopify.theme[triggerClass].init($block);
            });
          } else {
            if (Shopify.theme[triggerClass]) {
              // console.log('Block: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }
          }

        }
      }
    });
  }

  // Load video feature
  Shopify.theme.video.init();

  // Scrolling animations
  Shopify.theme.animation.init();

  // Initialize reviews
  Shopify.theme.productReviews.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Infinite scrolling
  Shopify.theme.infiniteScroll.init();

});


$(document)
.on('shopify:section:unload', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        // console.log('Section: ' + triggerClass + ' is unloaded.')
        Shopify.theme[triggerClass].unload($(section));
      } else {
        // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            // console.log('Block: ' + triggerClass + ' is unloaded.')
            Shopify.theme[triggerClass].unload($(this));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.unload($section);

  // QuantityBox
  Shopify.theme.quantityBox.unload($section);

  //Infinite scrolling
  Shopify.theme.infiniteScroll.unload($section);

});

$(document)
.on('shopify:section:select', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force show state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
      }
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  if ($('.newsletter-form__wrapper .contact-form').length > 0) {
    Shopify.theme.newsletterAjaxForm.init();
  }

  if(isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

  if ($('.block__recommended-products').length > 0) {
    var $productPage = $('.block__recommended-products').parents('.product-page');
    Shopify.theme.jsRecommendedProducts.init($productPage);
  }

});

$(document)
.on('shopify:section:deselect', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force hide state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
      }
    }
  }

});

// Block Shopify Shopify.theme editor events

$(document)
.on('shopify:block:select', function(e){

  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  var $block = $('#shopify-section-' + blockId);

  if($('.jsFeaturedPromos').length > 0) {
    Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
  }

  if($('.jsSlideshowWithText').length > 0) {
    Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
  }

  if ($('.jsSlideshowClassic').length > 0) {
    Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
  }

  if($('.jsTestimonials').length > 0) {
    Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
  }

  // Sidebar collection multi-tag filter
  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();
});

$(document)
.on('shopify:block:deselect', function(e){

  var $block = $('#shopify-section-' + e.detail.blockId);

  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
    }
  }

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {
  // Initialise Plyr on product description videos
  if ($('.product-description-video').length > 0) {
    const players = Plyr.setup('.product-description-video');
  }

  var $jsSections = $('.shopify-section[class*=js]');

  // Loop through sections with js classes and load them in
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        var triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(this));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }

      }
    }
  });

  var resizeTimer;

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      Shopify.theme.objectFitImages.calculateAspectRatio();
      Shopify.theme.jsProduct.disableSlideshow(null, $('.product-gallery__main:not([data-quickshop-gallery]), .product-gallery__thumbnails:not(.js-gallery-carousel)'));
      Shopify.theme.jsProduct.enableSlideshow($('.product-gallery__main:not([data-quickshop-gallery])'));

      if (!isScreenSizeLarge()){

        // When 798 or less
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.init();

      } else {

        // When larger than 798
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.unload();
        Shopify.theme.jsHeader.init($('.jsHeader'));

        // Swatches
        if(Shopify.theme_settings.product_form_style == 'swatches') {
          Shopify.theme.thumbnail.enableSwatches();
        }

        Shopify.theme.jsProduct.enableStickyScroll($('.product-template--image-scroll').find('.sticky-product-scroll'));
      }

    }, 250);

  });

  //Enable plyr
  Shopify.theme.video.init();

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // QuantityBox
  Shopify.theme.quantityBox.init();

  /* Show secondary image on hover */
  if (Shopify.theme_settings.show_secondary_image == true) {
    Shopify.theme.thumbnail.showVariantImage();
  }

  // Collection swatches
  if (Shopify.theme_settings.show_collection_swatches) {
    Shopify.theme.thumbnail.enableSwatches();
  }

  // Quick shop
  if (Shopify.theme_settings.enable_quickshop) {
    Shopify.theme.thumbnail.showQuickShop();
  }

  // Currency converter
  if (Currency.show_multiple_currencies) {
    Shopify.theme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($('[data-custom-pagination]').length) {
    Shopify.theme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });

  // Tabs
  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
  }

  // Accordion
  if($('.accordion, [data-cc-accordion]').length > 0) {
    Shopify.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if($('.slider, .flexslider').length > 0) {
    Shopify.contentCreator.slideshow.init();
  }

  // Newsletter AJAX Form
  if ($('.newsletter-form__wrapper .contact-form').length > 0) {
    Shopify.theme.newsletterAjaxForm.init();
  }

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Flickity IOS Fix
  Shopify.theme.flickityIosFix();


});

/*============================================================================
Slideshow arrows
==============================================================================*/



var arrowShape = 'M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z',
    arrowShapeThin = 'M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z';

$('.collection, .search-page').on('click', '.collection__sort-by-filter .sort_btn', function(e) {
  if ($(window).width() >= 768 || ($(window).width() < 768) && !$('.collection-sort').hasClass('active')) {
    $(this).toggleClass("active");
    $(".collection-sort.menu").toggleClass("active");
  }
});

$('.collection, .search-page').on('keydown', '.collection__sort-by-filter .sort_btn', function(e) {
  $('.collection .collection__sort-by-filter .sort_btn, .search-page .collection__sort-by-filter .sort_btn').trigger('click');
});

$('.collection, .search-page').on('click', '.boost-pfs-filter-option-item', function(e) {
  $(this)
    .closest('.boost-pfs-filter-option-content')
    .find('.boost-pfs-filter-apply-button')
    .trigger('click');
});

$('.collection, .search-page').on('click', function (e) {
  if ($(e.target).closest(".sort_btn").length === 0 && $(window).width() > 767) {
      $(".menu.collection-sort, .sort_btn").removeClass('active');
  }
});

$('.collection, .search-page').arrive('.boost-pfs-filter-option .boost-pfs-filter-option-content-inner', function() {
  // Fixed collection filter width
  if ($(window).width() > 767) {
    var $this = $(this);
    if ($(this).find('.boost-pfs-filter-option-item').length > 4) {
      $this.addClass('two-column-list');
    }
  }

  getFilterCount();

  $('.boost-pfs-filter-option-label, .boost-pfs-filter-clear-all').on('click', function (e) {
    setTimeout(function() {
      getFilterCount();
    }, 500);
  });

  // Filter open
  $('.collection, .search-page').on('click', '.boost-pfs-filter-tree-mobile-button button', function(e) {
    $('body').addClass('boost-pfs-filter-tree-open-body');
    $('.collection__filters_sort')
      .addClass('stick filter-open')
      .removeClass('sort-open');
    $('.boost-pfs-filter-tree').addClass('boost-pfs-filter-tree-mobile-open');
    if ($(window).width() <= 767) {
      $(".sort_btn").removeClass("active");
      closeSortFilter();
    }
    if ($(window).width() <= 767) {
      $(".sort_btn").removeClass("active");
      closeSortFilter();
    }
  });

  // Sort open
  $('.collection, .search-page').on('click', '.boost-pfs-filter-top-sorting .sort_btn', function(e) {
    if ($(window).width() <= 767) {
      $('body').addClass('boost-pfs-filter-tree-open-body');
      $('.collection__filters_sort')
        .addClass('stick sort-open')
        .removeClass('filter-open');
      $('.boost-pfs-filter-tree').removeClass('boost-pfs-filter-tree-mobile-open');
      $(".sort_btn").addClass("active");
      closeSortFilter();
    }
  });

  // Filter close
  $('.boost-pfs-filter-close').on('click', function (e) {
    closeSortFilterSidebar();
    sticktothetop();
  });


  $('.boost-pfs-filter-show-result').on('click', function (e) {
    closeSortFilterSidebar();
    sticktothetop();
  });


  // Sort close
  $('.collection, .search-page').on('click', '.close-container button, .bc-sf-filter-filter-dropdown a', function(e) {
    closeSortFilterSidebar();
    sticktothetop();
  });
});

$('.collection-product-filtering-overlay').on('click', function(e){ 
  e.preventDefault();
  $('.boost-pfs-filter-close')[0].click();
  $('.close-container button')[0].click();
});

$('.collection__filters.four-fifths.medium-down--four-fifths').on('click', function (e) {
  $(".sort_btn").removeClass("active");
});

$('.collection, .search-page').arrive('.collection__sort-by-filter .sort_btn', function() {
  if ($('.collection .collection__sort-by-filter .sort_btn').length > 0) {
    $('.collection .collection__sort-by-filter .sort_btn').attr('tabindex', '0');
  }

  if ($('.menu.collection-sort').length > 0) {
    $($('.menu.collection-sort .bc-sf-filter-filter-dropdown a')).attr('tabindex', '0');
  }
});

function closeSortFilterSidebar() {
  $('.collection__filters_sort').removeClass('filter-open sort-open');
  $(".collection-sort.menu, .sort_btn").removeClass("active");
  $('body').removeClass('boost-pfs-filter-tree-open-body');
}

function closeSortFilter() {
  if ($('.collection__filters_sort.sort-open, .collection__filters_sort.filter-open').length) {
    $('.collection-page').on('click', function(e) {
      if (!e.target.closest('.ss__sidebar')) {
        closeSortFilterSidebar();
      }
    });
  }
}

function sticktothetop() {
  // Make mobile sort and filter sticky when open and collection page is scrolled-down
  var window_top = $(window).scrollTop();
  var top = $('#stick-here').offset().top - 70;
  if (window_top > top) {
    var headerHeight = $('.header-sticky-wrapper.is-sticky').outerHeight();

    var announcementHeight = 0;
    var storeSelectorTabHeight = 0;
    
    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    }
    if (typeof Shopify.theme.jsStoreSelectorTab !== 'undefined' && Shopify.theme.jsStoreSelectorTab.enable_sticky) {
      storeSelectorTabHeight = Shopify.theme.jsStoreSelectorTab.getStoreSelectorTabHeight();
    }


    var totalHeight = headerHeight + storeSelectorTabHeight;

    $('#stickThis').addClass('stick');
    $('#stick-here').height($('#stickThis').outerHeight());
    $('#stickThis').css('top', totalHeight);
  } else if ($('.filter-open').length == 0 && $('.sort-open').length == 0) {
    removeStickyFilter();
  }
}

function getFilterCount() {
  // Get active filter count
  var count = $('.boost-pfs-filter-option-label.selected').length;
  if (count > 0) {
    $('.active-filter-count-wrapper').show();
    $('.active-filter-count').text(count);
  } else {
    $('.active-filter-count-wrapper').hide();
  }
}

$(function() {
  // Show atleast one active product description tab on desktop
  if ($(window).width() > 798) {
    var tabToShow = $('.product .product_tabs').find('li:not(.description):first > a').addClass('active').attr('href');
    $(tabToShow).addClass('active');
  }

  if ($('body').hasClass('collection') || $('body').hasClass('search')) {
    if ($(window).width() <= 767) {
      sticktothetop();
    } else {
      removeStickyFilter();
    }

    $(window).scroll(function(){
      if ($(window).width() <= 767) {
        sticktothetop();
      } else {
        removeStickyFilter(); 
      }
    });
  }
  modifyProductStars();
});

$('body').arrive('.yotpo .text-m', function() {
  modifyProductStars();
});

$('body').arrive('[data-retail-price]', function() {
  setTimeout(function() {
    showRetailPrice();
  }, 500);
});

function modifyProductStars () {
  $('.yotpo .text-m').each(function () {
    var reviewCount = $(this).text().replace('(','').replace(')','').replace(' Review','').replace(' Reviews','').replace('s','');
    $(this).html('(' + reviewCount + ')');
  
    if ($('body').hasClass('collection')) {
      if ($(this).text().toLowerCase().indexOf('write a review') >= 0) {
        $(this).closest('.yotpo-small').hide('');
      }
    }
  });
}

function removeStickyFilter() {
  $('#stickThis').removeClass('stick');
  $('#stick-here').height(0);
  $('#stickThis').css('top',0);
}

function showRetailPrice() {
  if ($('body').data('current-store') == 'Australia') {
    //Show difference of wholesale and retail product price
    $('[data-retail-price]').each(function () {
      var retailPrice = parseInt($(this).data('retail-price').replace("$", ""));
      var priceShown = parseInt($(this).text().replace("$", ""));
      if (retailPrice > priceShown) {
        if (!$(this).siblings('.was-price').text()) {
          var savings = (retailPrice - priceShown) * 100 / retailPrice;
          if ($(this).parent('.ajax-cart__price').length) {
            $(this)
            .addClass('sale')
            .after('<br><span class="was-price"><span class="money">$' + retailPrice.toFixed(2) + '</span></span>');
          } else if ($(this).closest('.cart__price').length) {
            $(this)
              .closest('.cart__price')
              .find('.retail-price')
              .remove();
            $(this)
              .addClass('sale')
              .closest('.cart__price p')
              .prepend('<span class="was-price retail-price"><span class="money">$' + retailPrice.toFixed(2) + '</span></span>');
          } else {
            $(this)
              .addClass('sale')
              .before('<span class="was-price"><span class="money">$' + retailPrice.toFixed(2) + '</span></span>')
              .after('<span class="sale savings">Save ' + savings.toFixed(0) + '%</span>')
              .closest('.product-thumbnail__price')
              .addClass('sale');
          }
        } else if ($(this).siblings('.was-price').text() && $(this).closest('.product__information').length) {
          retailPrice = parseInt($(this).siblings('.was-price').text().replace("$", ""));
          var savings = (retailPrice - priceShown) * 100 / retailPrice;
          $(this).siblings('.savings').text('Save ' + savings.toFixed(0) + '%')
        }
      }
    });
  }
}

$('body').on('mouseover', '.product__thumbnail:not(.sunny-product__thumbnail)', function(e) {
  if ($(window).width() > 1024) {
    var $this = $(this);
    var spaceLeft = $this.height() - $this.find('.image__container').height();
    var $thumbnail = $this.find('.thumbnail-overlay__container');
    var origHeight = $thumbnail.height();
    var extraSpace = spaceLeft - origHeight;
    
    $this.addClass('mouse-hover-js');
    if ($this.find('.quickshop-forms__container').length || $this.find('.signup-banner').length) {
      $thumbnail.addClass('has-add-to-cart');
    }
  
    var newHeight = $thumbnail.height();
    if (spaceLeft && newHeight > spaceLeft) {
      $thumbnail.css('margin-top',origHeight-newHeight+extraSpace);
    }
  }
});

$('body').on('mouseout', '.product__thumbnail', function(e) {
  if ($(window).width() > 1024) {
    var $thumbnail = $(this).find('.thumbnail-overlay__container');
    $(this).removeClass('mouse-hover-js');
    $thumbnail.css('margin-top',0);
  }
});

$('body').on('focusin', '.product__thumbnail:not(.sunny-product__thumbnail)', function(e) {
  if (!$(this).hasClass('focused')) {
    const $focusedElmt = $('.product__thumbnail.focused');
    if ($focusedElmt) {
      $focusedElmt.removeClass('focused');
      $focusedElmt.trigger('mouseout');
    }

    $(this).addClass('focused');
    $(this).trigger('mouseover');
  }
});

$('.collection').on('click', '.pagination a', function(e) {
  $('html, body').animate({
    scrollTop: $('.collection__main').offset().top - 230
  }, 1000);
});

// Newsletter
window.onload = function() { 
  // Scroll to bottom of page after newsletter sign up, hide form
  var $successMsg = $('#newsletter_form .quote');
  var $newsletterUrlParams = new URLSearchParams(window.location.search);

  if ($successMsg.is(':visible') && $successMsg.text() != "") {
    $('html, body').animate({
      scrollTop: $('#newsletter_form').offset().top - 130
    }, 'slow');
    $('.newsletter-form').hide();
  }

  if (!$('#newsletter_form .form__error').length && $newsletterUrlParams.getAll('contact[tags]').length && $newsletterUrlParams.get('form_type') === 'customer') {
    $('html, body').animate({
      scrollTop: $('#newsletter_form').offset().top - 130
    }, 'slow');
    $('.newsletter-form').hide();
    $('#newsletter_form').append('<p class=quote>Thanks! You Are Already A Member</p>')
  }

  // Scroll to top of page if recaptcha challenge is present
  var url = window.location.href;
  if (url.indexOf('/challenge#newsletter_form') != -1) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }
  showRetailPrice();
}

//Show instagram heading, once instagram widget is loaded
$(document).arrive('.instagram-widget .yotpo-pictures-widget .yotpo', function() {
  $('.instagram-widget .instagram-heading').show();
});


//custom code for Quiz Kit - adding class for styling
$(document).arrive('button[id*="quiz-kit-question-image-text-item-"]', function() {
  $(this).parent('div[id*="quiz-kit-question-grid-"]').addClass('grid-layout-question');

  if(($(this).parent('div[id*="quiz-kit-question-grid-"]').children().length) == 3){
    $(this).parent('div[id*="quiz-kit-question-grid-"]').addClass('three-questions');
  }
});



//custom code for Quiz Kit - appending terms and conditions text and override font size
var quizKitSubscribeclassCount = 0;
$(document).arrive('div[id*="quiz-kit-subscribe-"]', function() {
  if($('div[id*="quiz-kit-subscribe-"]').length > 0 ){
    quizKitSubscribeclassCount++;

    //override font size with font size set in attribute
    $('h1[id*="quiz-kit-subscribe-"]').attr('style', 'font-size:' +`${$('h1[id*="quiz-kit-subscribe-"]').attr("font-size")}px`+'!important');
    $('h2[id*="quiz-kit-subscribe-"]').attr('style', 'font-size:' +`${$('h2[id*="quiz-kit-subscribe-"]').attr("font-size")}px`+'!important');
  }

  if(quizKitSubscribeclassCount == 1){
    $('div[id*="quiz-kit-subscribe-"] div[id*="quiz-kit-container"] > div').append(
      '<p class="terms-conditions-message">By providing your email address you are opting into Club Bondi to receive the latest offers and new arrivals. You are also accepting our <a href="/pages/terms-conditions" target="_blank">T&Cs</a>.</p>'
      );
  }
});


//custom code for Quiz Kit - product add to cart
$(document).arrive('div[id*="quiz-kit-results-grid-"]', function() {
  $('div[id*="quiz-kit-results-product-"] button').on('click', function(){
      if($(this).html().toLowerCase() == 'add to bag'){
         setTimeout(function(){ 
      Shopify.theme.jsAjaxCart.initializeAjaxCart();
         }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
      }
  });
  
  $('div[id*="quiz-kit-results-grid-"] > div:nth-child(1)').prepend('<span class="product-heading">TAN</span>');
  $('div[id*="quiz-kit-results-grid-"] > div:nth-child(2)').prepend('<span class="product-heading">APPLY</span>');
  $('div[id*="quiz-kit-results-grid-"] > div:nth-child(3)').prepend('<span class="product-heading">FACE</span>');
  $('div[id*="quiz-kit-results-grid-"] > div:nth-child(4)').prepend('<span class="product-heading">MAINTAIN</span>');
});

//custom code for Quiz Kit - header banner
$(document).arrive('#quiz-kit-content', function() {
    if(!$('.shade-finder-quiz')) {
      $('#quiz-kit-content').prepend(`
        <img class="quiz-kit-header--desktop" src="https://cdn.shopify.com/s/files/1/0434/1438/8897/files/bondi-rewards-header-desktop.jpg?v=1632212181"
        style="
        max-height: 600px;
        height: 100%;
        width: 100%;
        object-fit: cover;"
        alt="Bondi Babe Rewards"
        />`
      );
    
      $('#quiz-kit-content').prepend(`
        <img class="quiz-kit-header--mobile" src="https://cdn.shopify.com/s/files/1/0434/1438/8897/files/bondi-rewards-header-mobile.jpg?v=1631682477" 
        alt="Bondi Babe Rewards"/>`
      );
    
      if($(window).width() > 768){
        $('.quiz-kit-header--desktop').show();
        $('.quiz-kit-header--mobile').hide();
      }
      else{
        $('.quiz-kit-header--desktop').hide();
        $('.quiz-kit-header--mobile').show();
      }

    $(window).resize(function(){
      if($(window).width() > 768){
        $('.quiz-kit-header--desktop').show();
        $('.quiz-kit-header--mobile').hide();
      }
      else{
        $('.quiz-kit-header--desktop').hide();
      }
    });
  }
});

$(document).arrive('div[id*="quiz-kit-question-"]', function() {
  $('.quiz-kit-header--mobile').hide();
});

//Locksmith Password protected page
$(document).arrive('#locksmith-content', function(){
  $("#locksmith_passcode").attr("placeholder", "Enter Password");
  $('#locksmith_passcode_submit .default').text('Enter');

  $('#locksmith-passcode-form').append(`<div class="input-wrapper"></div>`)
  $('#locksmith-passcode-form > p:nth-child(4)').appendTo($('.input-wrapper'));
  $('#locksmith-passcode-form > p:nth-child(4)').appendTo($('.input-wrapper'));
  window.scrollTo({top: 0});

  if($(window).width() <= 768){
    window.scrollTo({top: 10});
    $('body').addClass('locksmith-password-page');
  }
})

//“On Demand” YouTube loading for Youtube embeds
$(document).ready(function() {
  initYouTubeVideos();
});

function labnolIframe(div) {
  var iframe = document.createElement('iframe');
  iframe.setAttribute(
    'src',
    'https://www.youtube.com/embed/' + div.dataset.id + '?autoplay=1&rel=0&mute=1&modestbranding=1&showinfo=0&controls=1&playsinline=1'
  );
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute(
    'allow',
    'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
  );
  div.parentNode.replaceChild(iframe, div);
}

function initYouTubeVideos() {
  var playerElements = document.getElementsByClassName('youtube-player');
  for (var n = 0; n < playerElements.length; n++) {
    var videoId = playerElements[n].dataset.id;
    var div = document.createElement('div');
    div.setAttribute('data-id', videoId);
    var thumbNode = document.createElement('img');
    thumbNode.src = '//i.ytimg.com/vi/ID/maxresdefault.jpg'.replace(
      'ID',
      videoId
    );
    div.appendChild(thumbNode);
    var playButton = document.createElement('div');
    playButton.setAttribute('class', 'play');
    div.appendChild(playButton);
    div.onclick = function () {
      labnolIframe(this);
    };
    playerElements[n].appendChild(div);
  }
}

function checkUTMSource(){
  const UTMSource = localStorage.getItem('UTM_SOURCE');
  if(!UTMSource){
    // Get the query string from the current URL
    const queryString = window.location.search;

    // Parse the query string into a URLSearchParams object
    const urlParams = new URLSearchParams(queryString);

    // Get the value of a parameter named "paramName"
    const paramValue = urlParams.get('utm_source');
    if(paramValue){
      localStorage.setItem('UTM_SOURCE', paramValue)
    }
  }
  
  if (location.pathname === '/') {
    localStorage.removeItem('UTM_SOURCE');
  }
}
checkUTMSource();

// rebuy minicart widgets
document.addEventListener('rebuy:smartcart.ready', () => {
  const rebuyDiscountCodeInit = () => {

    $('.discount-code-wrapper').click(function() {
      $('.rebuy-cart__flyout-discount-container').toggleClass('active')
    })
  }

  rebuyDiscountCodeInit();
});

// rebuy minicart total savings
document.addEventListener('rebuy:cart.change', () => {

  const rebuyProductLimitInit = () => {
    const Cart = window.Rebuy.Cart;
    if (Shopify.theme_settings.limit_quantity_10 == true && Cart.hasItems()) {
      let cartItems = Cart.items();
      let overQtyIndex = [];
      for (var i = 0; i < cartItems.length; i++) {
        if (cartItems[i].quantity > 10) {
          overQtyIndex += i;
        }
      };
      if (overQtyIndex.length) {
        setTimeout(() => {
          // timeout to let product metafields load
          for (var i = 0; i < overQtyIndex.length; i++) {
            let item = cartItems[overQtyIndex[i]];
            let overQtyMetafields = item.product.metafields.global;
            let isWholesaleProduct = (overQtyMetafields.wholesaleAU || overQtyMetafields.Wholesale || overQtyMetafields.WholesaleAU || overQtyMetafields.Wholesale) ? true : false;
            if (!isWholesaleProduct) {
              jQuery.post('/cart/change.js', { quantity: 10, id: item.id });
            }
          }
        }, 200);
      }
    };
  };

  const rebuyTotalSavingInit = () => {
    $.ajax({
      url: '/cart',
      success: function(data) {
        totalSavings = $(data).find('.cart__total-discount span');
        $('.rebuy-total-savings').remove();
        if (totalSavings.length) {
          const totalSavingsDiv = `<div class="rebuy-total-savings"><span>Total Saving:</span><span>${totalSavings.text()}</span></div>`;
          $('.rebuy-cart__flyout-subtotal').after(totalSavingsDiv);
        }
      }
    });
  }

  rebuyTotalSavingInit();
  rebuyProductLimitInit();
});

document.addEventListener('rebuy:cart.enriched', (event) => { 
  // rebuy init announcement bar
  const rebuyAnnouncementBarInit = () => {
    if ($('#rebuy-smart-cart-announcement-bar').is(':visible') && $('#rebuy-smart-cart-announcement-bar.splide').length <= 0 && $('#rebuy-smart-cart-announcement-bar.flickity').length <= 0) {
      $('#rebuy-smart-cart-announcement-bar').flickity({
        cellSelector: '.rebuy-cart__flyout-announcement-bar-message',
        cellAlign: "left",
        wrapAround: true,
        groupCells: true,
        lazyLoad: true,
        imagesLoaded: true,
        autoPlay: true,
        prevNextButtons: false,
        pageDots: false
      });
    }
  }
  
  if ($('#rebuy-smart-cart-announcement-bar').length > 0) {
    setTimeout(rebuyAnnouncementBarInit, 50);
  }
});

// yotpo PDP review widget
$(document).arrive('#yotpo-reviews-main-widget', function() {
  $('#yotpo-reviews-main-widget').css('--primary-font-family', 'Open Sans');
  $('#yotpo-reviews-main-widget').css('--secondary-font-family', 'Open Sans');
})
$(document).arrive('.yotpo-reviews-main-widget.yotpo-main-widget-layout', function() {
  $('.yotpo-reviews-main-widget.yotpo-main-widget-layout').css('--primary-font-family', 'Open Sans');
  $('.yotpo-reviews-main-widget.yotpo-main-widget-layout').css('--secondary-font-family', 'Open Sans');
})

// Custom SearchSpring
$(document).arrive('.searchspring-ac+.ss__autocomplete--target', () => {

  $headerSearchBar = $('.header__icons').find('.header-search-input');
  $headerSearchIcon = $('.header__icons').find('.header-search-icon');
  $headerMenu = $('.header__menu').find('.header__menu-items');
  $headerAccount = $('.header__icons').find('.header__link-account');

  if ($headerSearchBar.hasClass('active')) {
    window.addEventListener('scroll', () => {
      $headerSearchBar.removeClass('active');
      $headerMenu.removeClass('active');
      $headerAccount.removeClass('search-open');
      $('#search__desktop').blur();
    })
  }

  // Desktop
  $('#search__desktop').on('focus', (e)=> {
    e.preventDefault();

    const ss_autocomplete__desktop = $('#search__desktop.searchspring-ac+.ss__autocomplete--target');
    const ss_autocomplete_children__desktop = ss_autocomplete__desktop.children();
    const search_value__desktop = $('#search__desktop')?.val();
    
    let ss_auto_complete__temp_container__desktop = $('.ss__autocomplete--target--temp--desktop').find('.ss__autocomplete').clone();
      ss_auto_complete__temp_container__desktop.addClass('temp')
    
    if (search_value__desktop.length <= 0) {
      e.stopImmediatePropagation();
    }
    if (search_value__desktop.length <= 0 && ss_autocomplete__desktop.find('.ss__autocomplete.temp').length <= 0) {
        ss_autocomplete__desktop.append(ss_auto_complete__temp_container__desktop);
    }
  })

  $('#search__desktop').on('keydown', (e)=> {
    const ss_autocomplete__desktop = $('#search__desktop.searchspring-ac+.ss__autocomplete--target');
    const ss_autocomplete_children__desktop = ss_autocomplete__desktop.children();
    const search_value__desktop = $('#search__desktop')?.val();
    
    let ss_auto_complete__temp_container__desktop = $('.ss__autocomplete--target--temp--desktop').find('.ss__autocomplete').clone();
    ss_auto_complete__temp_container__desktop.addClass('temp')
    
    setTimeout(() => {
      if(ss_autocomplete__desktop.find('.ss__autocomplete.temp').length <= 0) {
          ss_autocomplete__desktop.append(ss_auto_complete__temp_container__desktop);
      }
    })
  });

  $('#search__desktop').on('blur', (e)=> {
    e.preventDefault();
    e.stopImmediatePropagation();
    if ($(e.originalEvent.relatedTarget).closest('.header-search-input.active').length <= 0)
      setTimeout(() => {
        $('#search__desktop.searchspring-ac+.ss__autocomplete--target').find('.ss__autocomplete.temp').remove();
        $headerSearchBar.removeClass('active');
        $headerMenu.removeClass('active');
        $headerAccount.removeClass('search-open');
      }, 300)
  })

  // Mobile
  const mobileCustomSearchSpringAutoComplete = () => {
    const ss_autocomplete__mobile = $('#search__mobile.searchspring-ac+.ss__autocomplete--target');
    const ss_autocomplete_children__mobile = ss_autocomplete__mobile.children();
    const search_value__mobile = $('#search__mobile')?.val();

    let ss_auto_complete__temp_container__mobile = $('.ss__autocomplete--target--temp--mobile').find('.ss__autocomplete').clone();
      ss_auto_complete__temp_container__mobile.addClass('temp')

    if (search_value__mobile.length <= 0 && ss_autocomplete__mobile.find('.ss__autocomplete.temp').length <= 0) {
      ss_autocomplete__mobile.append(ss_auto_complete__temp_container__mobile);
    }
  }
  
  $('#search__mobile').on('input', (e)=> {
    if ($('#search__desktop').length > 0) {
      $('#search__desktop.searchspring-ac+.ss__autocomplete--target').find('.ss__autocomplete.temp').remove();
    }
    if ($('#search__mobile').length > 0) {
      $('#search__mobile.searchspring-ac+.ss__autocomplete--target').find('.ss__autocomplete.temp').remove();
    }
    mobileCustomSearchSpringAutoComplete()
    // setTimeout(() => {
    //   $('.searchspring-ac#search__mobile+.ss__autocomplete--target .ss__autocomplete__content')[0].scrollIntoView(true);
    // }, 300)
  });

  $('[for=mobile--search-chk]').on('click', () => {
    mobileCustomSearchSpringAutoComplete();
    $('.searchspring-ac#search__mobile+.ss__autocomplete--target .ss__autocomplete__content')[0].scrollIntoView(true);
  });

  $('#search__mobile').on('blur', mobileCustomSearchSpringAutoComplete);
  $('#search__mobile').on('focus', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    mobileCustomSearchSpringAutoComplete();
  });
}) 
